import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { VERSION as CDK_VERSION } from '@angular/cdk';
import { MAT_RIPPLE_GLOBAL_OPTIONS, VERSION as MAT_VERSION, MatDateFormats, MatNativeDateModule } from '@angular/material/core';
import { provideServiceWorker } from '@angular/service-worker';
import { LOCALE_ID, DEFAULT_CURRENCY_CODE } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
registerLocaleData(localeFr, 'fr');
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MarkdownModule } from 'ngx-markdown';
import { providePrimeNG } from 'primeng/config';
import D4MaterialPreset from '../assets/sharedSpaAssets/primeNgTheming';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CustomNgxDatetimeAdapter } from './global/services/CustomNgxDatetimeAdapter';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { intercept as interceptJwt } from './global/services-interceptor/jwt.service';
import { intercept as interceptError } from './global/services-interceptor/error.service';


const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: "l, LTS"
  },
  display: {
    dateInput: "l, LTS",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

console.info('Angular CDK version', CDK_VERSION.full);
console.info('Angular Material version', MAT_VERSION.full);

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(MatDatepickerModule),
    importProvidersFrom(ScrollingModule),
    importProvidersFrom(MatNativeDateModule),
    providePrimeNG({
      theme: {
        preset: D4MaterialPreset,
        options: {
          darkModeSelector: false || 'none',
        }
      }
    }),
    importProvidersFrom(MarkdownModule.forRoot()),
    provideAnimations(),
    provideHttpClient(withInterceptors([interceptJwt, interceptError])),
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: false } },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: DateAdapter, useClass: CustomNgxDatetimeAdapter, deps: [MAT_DATE_LOCALE] },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:9000',
    }),
  ],
};
